'use-strict';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import '@/sass/shared.scss';

import vjs from '@/globals/vjs/vjs';

window.AHA = window.AHA || {};

window.AHA = {
    ...window.AHA,
    ...vjs
};

window.AHA.vjs.$create();
